import type { ActivityModule } from '../../core/activity';
import { mountGnumchEquality } from './ui';
import levelsData from './levels.json';
import './style.css';

export const gnumchEquality: ActivityModule = {
  id: 'gnumch-equality',
  title: 'Comilão de números',
  description: 'Guie o Comilão até as expressões cujo resultado bate com a meta. Cuidado com os fantasmas!',
  ageMin: 7,
  ageMax: 11,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/gnumch-equality/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountGnumchEquality,
};
